import { useEffect } from "react";
import "../scss/terms.scss";

interface FaqsProps {
  loaderStatus?: (status: boolean) => void;
}

const Faqs = ({ loaderStatus }: FaqsProps) => {
  // Static page: nothing to fetch, so clear the global loading overlay on mount.
  useEffect(() => {
    loaderStatus?.(true);
  }, [loaderStatus]);

  return (
    <>
      <div className="jazz_discount_outer">
        <div className="container">
          <div className="discount_inner">
            <h2>Frequently Asked Questions</h2>
            <h3>How can I subscribe to this if I am not a jazz customer?</h3>
            <p>
              This service is only available for Jazz Customers.
              <br />
              <br />
              Users can subscribe to Sekho via 2 mediums:
              <br />
              <br />
              SMS: Send ‘SUB’ on 5371.
              <br />
              <br />
              IVR: Dial 5371 and listen to the menu to get a subscription by
              pressing 1
            </p>
            <h3>How can I find my grade courses?</h3>
            <p>
              Follow the following steps:
              <br />
              <br />
              Open JP app
              <br />
              <br />
              Tap on “student grades 1-12”
              <br />
              <br />
              Select your grade and start learning
            </p>
            <h3>Can I use this app on my laptop?</h3>
            <p>
              Yes you can use it on the laptop by following the steps
              <br />
              <br />
              Open JP web
              <br />
              <br />
              Enter your number and get “OTP”
              <br />
              <br />
              Open the web and start learning
            </p>
            <h3>How many courses I can find in this app?</h3>
            <p>
              You can find the following courses;
              <br />
              <br />
              Executive Training (25 courses)
              <br />
              <br />
              Vocational Training (16 courses)
              <br />
              <br />
              Language learning (7 languages)
              <br />
              <br />
              Student Grades (1-12)
              <br />
              <br />
              Exams tips and tricks for all grades
            </p>
            <h3>
              Is this app providing conceptual knowledge other than books?
            </h3>
            <p>
              Yes, this app is providing conceptual knowledge other than books.
              For more, you can explore “student grade 1-12”
            </p>
            <h3>Can I learn soft skills through this app?</h3>
            <p>
              You can learn soft skills through Sekho by following the
              steps
            </p>
            <ul className="number-ul">
              <li>Open JP app</li>
              <br />
              <li>Tap on executive training</li>
            </ul>
            <h3>Is this app helpful for people who want to learn e-courses?</h3>
            <p>
              Sekho is very helpful for people who want to learn e-courses
              <br />
              <br />
              You can learn different e-courses by following the steps
            </p>
            <ul className="number-ul">
              <li>Open JP app</li>
              <br />
              <li>Tap on “executive training” you can find 25 e-courses</li>
              <br />
              <li>Tap on “vocational training” you can find 16 e-courses</li>
            </ul>
            <h3>How can I Unsubscribe from JP?</h3>
            <p>
              Users can unsubscribe from Sekho by two different ways:
              <br />
              <br />
              SMS: Send ‘UNSUB’ on 5371.
              <br />
              <br />
              IVR: Call on 5371 and listen to the menu & get unsubscribed by
              pressing 0.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};
export default Faqs;
